import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CouponInfoComponent } from './coupon-info/coupon-info.component';
import { SharedModule } from '../../shared/shared.module';



@NgModule({
  declarations: [CouponInfoComponent],
  exports: [CouponInfoComponent],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class CouponInfoModule { }
